import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import VueCookies from 'vue-cookies'
import VueAxios from 'vue-axios'
import echo from '@/libs/echo'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import '@/libs/cookie'
import '@/libs/date-picker'
// Axios Mock Adapter
import '@/@fake-db/db'
import VueNativeNotification from 'vue-native-notification'
import moment from 'vue-jalali-moment'
import PersianCalendar from 'vue-persian-calendar'
import axios from '@axios'

Vue.use(moment)

Vue.use(PersianCalendar)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(VueCookies)
Vue.use(VueAxios, axios)
Vue.use(echo)
Vue.use(VueNativeNotification, {
  requestOnNotify: true,
})
// Vue.use(firebaseHelper)
// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
